


















import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import PvLogsTable from '../components/PvLogsTable.vue';
import { Component, Vue } from 'vue-property-decorator';
import { pvLogApi } from '../pv-log.api';

@Component({
  components: {
    TitleBar,
    CardComponent,
    PvLogsTable,
  },
})
export default class PvLogList extends Vue {
  public sort: any = null;
  public filters: any = null;
  public get titleStack(): string[] {
    return ['Admin', 'Logs PV'];
  }

  public get exportUrl(): string {
    const sort = this.sort || [];
    const filters = this.filters || {};

    return pvLogApi.getExportUrl({ sort, filters });
  }
}
